import { render, staticRenderFns } from "./CampaignDeliveryType.vue?vue&type=template&id=e8081c5c&"
import script from "./CampaignDeliveryType.vue?vue&type=script&lang=js&"
export * from "./CampaignDeliveryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports